module.exports = __webpack_public_path__ + "img/icon-form-checkbox.e0d3827c.jpg";